import * as _ from 'lodash'

export const HolesUnique = (products) => {
    let holeAll = []
    for (let i = 0; i < products.length; i++) {
        holeAll = holeAll.concat(products[i].Agujero.trim())
    }
    const hole = holeAll.filter(item => item)
    let distinct = _.uniq(hole);
    return distinct
}